import React from "react";
import { Provider } from "react-redux";

import store from "./services/store";
import { MuiThemeProvider, createTheme } from "@material-ui/core";

const theme = createTheme({
  palette: {
    primary: {
      main: "#e67e22",
    },
    secondary: {
      main: "#0046AD",
    },
    contrastThreshold: 2,
  },
});

export default function Root({ children, initialState = {} }) {
  return (
    <MuiThemeProvider theme={theme}>
      <Provider store={store(initialState)}>{children}</Provider>
    </MuiThemeProvider>
  );
}
